import React from 'react';
import styled from 'styled-components';
import { Text } from '@libs/uikit/Components';

const StyledText = styled(Text)`
    color: #8c9094;
`;

export const TextWithPreview = ({ children, ...props }) => {
    return (
        <StyledText caption inline noMargin {...props}>
            {children}
        </StyledText>
    );
};
